<template>
    <div v-if="display">
        <div class="banner">
            <div class="container">
                <div class="info">
                    <div v-if="isLogged" class="wrap_box">
                        <div class="boxContainer">
                            <div class="news-text-title">{{ $t('top.notices.title') }}</div>
                            <div v-if="!isNothingNewsData" class="news-text-link"><router-link to="/news"　class="news-link">{{ $t('top.notices.link') }}</router-link></div>
                        </div>
                        <div v-if="!isNothingNewsData" class="boxesContainer">
                            <div class="wrap-news">
                                <div class="parent">
                                    <div class="child">
                                        {{ this.newsData[0].day }}
                                    </div>
                                    <div class="child">
                                        <router-link :to="this.newsData[0].link">
                                            <span v-if="this.newsData[0].new" class="new">{{ $t('top.notices.new') }}</span>
                                            <span class="title">{{ this.newsData[0].title }}</span>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="parent">
                                    <div class="child">
                                        {{ this.newsData[1].day }}
                                    </div>
                                    <div class="child">
                                        <router-link :to="this.newsData[1].link">
                                            <span v-if="this.newsData[1].new" class="new">{{ $t('top.notices.new') }}</span>
                                            <span class="title">{{ this.newsData[1].title }}</span>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="parent">
                                    <div class="child_end">
                                        {{ this.newsData[2].day }}
                                    </div>
                                    <div class="child_end">
                                        <router-link :to="this.newsData[2].link">
                                            <span v-if="this.newsData[2].new" class="new">{{ $t('top.notices.new') }}</span>
                                            <span class="title">{{ this.newsData[2].title }}</span>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="boxesContainer">
                            <div class="wrap-news">
                                <div class="parent">
                                    {{ $t('top.notices.newsdatanotfound') }}
                                </div>
                            </div> 
                        </div>
                    </div>
                    <div v-if="latestMembershipFee && !latestMembershipFee.is_active && !notForceClubMember">
                        <div class="forthingRenewalBox">
                            <div class="forthingRenewalTextLink">
                                <div v-if="((this.membertypeDetail == 'PREMIUM_MEMBER' || 
                                    this.membertypeDetail == 'UPGRADE_PREMIUM_MEMBER_PAYOUT_BELOW_CONTRACT'))">
                                    <router-link to="/messages">{{ $t('top.forthing-renewal.forthing-renewal-text',{ firstName: userData.first_name, lastName: userData.last_name, expiresAt: expires_at }) }}</router-link>
                                </div>
                                <div v-else-if="((this.membertypeDetail == 'SUPPORT_MEMBER' || 
                                    this.membertypeDetail == 'UPGRADE_PREMIUM_MEMBER_PAYOUT_OR_OVER_CONTRACT'))">
                                    <router-link to="/messages">{{ $t('top.forthing-renewal-support.forthing-renewal-text',{ firstName: userData.first_name, lastName: userData.last_name, expiresAt: expires_at, forthingRenewalDate: forthingRenewalDate}) }}</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="displayRank">
                        <div class="exLankContainer">

                            <div class="exLankTextTitle">Status</div>
                            <div class="exLankParentTop">
                                <div class="exLankchild exLankName fontSizeName">AUBE ID</div>
                                <div class="exLankchild exLankValue">
                                    <div class="fontSize">{{ data.email }}</div>
                                </div>
                            </div>

                            <div class="exLankParent">
                                <div class="exLankchild exLankName fontSizeName">Force ID</div>
                                <div class="exLankchild exLankValue">
                                    <div class="fontSize">{{ data.force_club_id }}</div>
                                </div>
                            </div>

                            <div v-if="!isLankSp" class="exLankchild exLankValue">
                                <div class="exLankParentEnd">
                                    <div class="floteLeft">
                                        <div class="exLankchild exLankName fontSizeName floteLeft">EX RANK</div>
                                        <div v-if="(isGrantDate())" class="exChangeTwoMonths fontSize floteLeft">[{{this.grantdate['month']}}-{{this.grantdate['year']}}]</div>
                                        <div v-if="(! isGrantDate())" class="exChangeTwoMonths fontSize floteLeft">[&ensp;&ensp;&ensp;-&ensp;&ensp;&ensp;]</div>
                                        <div v-if="(isExRankMonth())" class="fontSize floteLeft">{{ data.title.ex_month_title.rank }}</div>
                                        <div v-if="(! isExRankMonth())" class="fontSize floteLeft">&ensp;&ensp;&ensp;-&ensp;&ensp;&ensp;</div>
                                        <div class="fontSize floteLeft" style="margin-left: 5px; margin-right: 5px;">/</div>
                                        <div class="exRecordHigt fontSize floteLeft">[Record high]</div>
                                        <div v-if="(isExRankMax())" class="exChangeHighLank fontSize floteLeft">{{ data.title.ex_max_title.rank }}</div>
                                        <div v-if="(! isExRankMax())" class="exChangeHighLank fontSize floteLeft">&ensp;&ensp;&ensp;-&ensp;&ensp;&ensp;</div>
                                    </div>
                                    <div class="fontSize floteLeft">
                                        <div class="fontSize floteLeft">UPDATE:</div>
                                        <div class="fontSize floteLeft" style="margin-right: 5px;">{{this.updated['day']}}</div>
                                        <div v-if="(isUpDate())" class="fontSize floteLeft">{{this.updated['month']}}-</div>
                                        <div v-if="(isUpDate())" class="fontSize floteLeft">{{this.updated['year']}}</div>
                                        <div v-if="(! isUpDate())" class="fontSize floteLeft">&ensp;&ensp;&ensp;&ensp;&ensp;-&ensp;&ensp;&ensp;</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="isLankSp" class="exLankchild exLankValue">
                                <div class="exLankParentEnd">
                                    <div class="fontSize floteLeft">
                                        <div class="exLankchild exLankName fontSizeName floteLeft">EX RANK</div>
                                        <div v-if="(isGrantDate())" class="exChangeTwoMonths fontSize floteLeft">[{{this.grantdate['month']}}-{{this.grantdate['year']}}]</div>
                                        <div v-if="(! isGrantDate())" class="exChangeTwoMonths fontSize floteLeft">[&ensp;&ensp;&ensp;-&ensp;&ensp;&ensp;]</div>
                                        <div v-if="(isExRankMonth())" class="fontSize floteLeft">{{ data.title.ex_month_title.rank }}</div>
                                        <div v-if="(! isExRankMonth())" class="fontSize floteLeft" >&ensp;&ensp;&ensp;-&ensp;&ensp;&ensp;</div>
                                        <div class="fontSize floteLeft" style="margin-left: 2px; margin-right: 2px;">/</div>
                                        <div class="exRecordHigt fontSize floteLeft">[Record high]</div>
                                        <div v-if="(isExRankMax())" class="exChangeHighLank fontSize floteLeft">{{ data.title.ex_max_title.rank }}</div>
                                        <div v-if="(! isExRankMax())" class="exChangeHighLank fontSize floteLeft">&ensp;&ensp;&ensp;-&ensp;&ensp;&ensp;</div>
                                    </div>
                                </div>
                                <div class="exLankParentEndSp fontSize">
                                    <div class="fontSize floteLeft">UPDATE:</div>
                                    <div class="fontSize floteLeft" style="margin-right: 5px;">{{this.updated['day']}}</div>
                                    <div v-if="(isUpDate())" class="fontSize floteLeft">{{this.updated['month']}}-</div>
                                    <div v-if="(isUpDate())" class="fontSize floteLeft">{{this.updated['year']}}</div>
                                    <div v-if="(! isUpDate())" class="fontSize floteLeft">&ensp;&ensp;&ensp;&ensp;&ensp;-&ensp;&ensp;&ensp;</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h1 style="padding-top: 50px;">
                        <img class="pc" :src="this.images.ttlPc" alt="">
                        <img class="sp" :src="this.images.ttlSp" alt="">
                    </h1>
                    <p>
                        <img class="pc" :src="this.images.txtPc" alt="">
                        <img class="sp" :src="this.images.txtSp" alt="">
                    </p>
                    <div class="img">
                        <img class="logo" src="./images/img_01.png" alt="">
                    </div>
                </div>
            </div>
        </div>

        <footer-menu :isAuth="isAuth" :displayLogin="displayLogin" :showMenu="false"></footer-menu>

        <div v-if="!isLogged" class="greyBox">
            <div class="container">
                <div class="page-header">
                    <h2>{{ $t('top.box1.title') }}</h2>
                    <p v-html="'' + $t('top.box1.text[0]')"></p>
                    <p v-html="'' + $t('top.box1.text[1]')"></p>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-4 col-xs-12">
                        <div class="img">
                            <img src="./images/img_02.png" alt="">
                        </div>
                        <p>{{ $t('top.box1.point1') }}</p>
                    </div>
                    <div class="col-md-4 col-xs-12">
                        <div class="img">
                            <img src="./images/img_03.png" alt="">
                        </div>
                        <p>{{ $t('top.box1.point2') }}</p>
                    </div>
                    <div class="col-md-4 col-xs-12">
                        <div class="img">
                            <img src="./images/img_04.png" alt="">
                        </div>
                        <p v-html="'' + $t('top.box1.point3')"></p>
                    </div>
                </div>
            </div>
        </div>


        <div v-if="!isLogged" class="container">
            <div class="whiteBox">
                <div class="row">
                    <div class="col-lg-6 col-xs-12 left">
                        <h3>{{ $t('top.box2.title') }}</h3>
                        <p>{{ $t('top.box2.text[0]') }}</p>
                        <p class="mb-4">{{ $t('top.box2.text[1]') }}</p>
                        <p class="mb-4">{{ $t('top.box2.text[2]') }}</p>
                        <p class="mb-4">{{ $t('top.box2.text[3]') }}</p>
                        <p>{{ $t('top.box2.text[4]') }}</p>
                    </div>
                    <div class="col-lg-6 col-xs-12 row no-gutters right align-items-center justify-content-center">
                        <img src="./images/img_09.png" alt="">
                    </div>
                </div>
            </div>
        </div>

        <div class="gradientBox index">
            <div class="container">
                <h3 v-html="'' + $t('top.box3.title')"></h3>
                <div class="contentList">
                    <div class="contentItem" v-for="content in images.contents">
                        <a v-bind:style="{'background': 'url(' + content.src + ') center no-repeat'}">
                            <div class="title">{{ $t(content.itemKey) }}</div>
                        </a>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="button button2 row no-gutters pick">
                    <a href="/studies-top" class="col-lg-6 col-xs-12">
                        <button type="button" class="btn">{{ $t('top.box3.link') }}</button>
                    </a>
                </div>
            </div>
        </div>

        <div v-if="isOpenImg01Modal"
             :class="['modal', 'fade', {show: isOpenImg01Modal}]"
             tabindex="-1"
             role="dialog"
             @click="handleOnClickCloseImg1Modal()">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <img src="./images/img_05_sp.png" alt="">
                </div>
            </div>
        </div>

        <div v-if="isOpenImg02Modal"
             :class="['modal', 'fade', {show: isOpenImg02Modal}]"
             tabindex="-1"
             role="dialog"
             @click="handleOnClickCloseImg2Modal()">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <img src="./images/img_06_sp.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AuthUtil from '../../utils/AuthUtil';
    import { FORTHING_MEMBER_PARENT, FORTHING_MEMBER_SUPPORT_PARENT } from '../../utils/AuthUtil';
    import FooterMenu from '../../components/FooterMenu/FooterMenu.vue';
    import languageService from '../../services/LanguageService';
    import userService from '../../services/UserService';
    import NewsDataService from '../../services/NewsDataService';
    import JSCookie from 'js-cookie';
    import config from './../../../config';

    export default {
        name: 'home',

        components: {
            FooterMenu
        },

        data() {
            return{
                isAuth: false,
                isOpenImg01Modal: false,
                isOpenImg02Modal: false,
                displayLogin: true,
                lang: 'en',
                contentImagePath: '/cai/common/images/info-screen/',
                contentIds: [20, 3, 6, 16, 27, 34],
                images: {
                    ttlPc: '',
                    ttlSp: '',
                    txtPc: '',
                    txtSp: '',
                    contents: []
                },
                isLogged: true,
                isLankSp: false,
                postdata: [],
                arrReverse: [],
                display: false,
                d: '',
                startDate: '',
                endDate: '',
                newsData: '',
                newsDataLength: '',
                beforeWeek: '',
                xday: '',
                startYear: '',
                startMonth: '',
                startDay: '',
                today: '',
                data: undefined,
                displayRank: false,
                grantdate: [
                    {year: undefined},
                    {month: undefined},
                    {day: undefined}
                ],
                updated: [
                    {year: undefined},
                    {month: undefined},
                    {day: undefined}
                ],
                ex_bonus_title: undefined,
                latestMembershipFee: undefined,
                userData: undefined,
                expires_at: undefined,
                isAdvanceMember: false,
                membertypeDetail: undefined,
                forthingRenewalDate: undefined,
                locale: '',
                getData: [],
                isNothingNewsData: false

            }
        },
        methods: {
            async fetchUserFrontendData() {
                try {
                    if (window.matchMedia( "(max-width: 479px)" ).matches) {
                        /* ウィンドウサイズが 479px以下(SP)の場合*/
                        this.isLankSp = true
                    }  
                    this.locale = JSCookie.get('app_locale') ? JSCookie.get('app_locale') : config.defaultLanguage;   
                    this.getData = await NewsDataService.getNewsData(this.locale);  
                    this.newsData = this.getData.data;
                    if (this.newsData.length < 1) {
                        this.isNothingNewsData = true;
                    }
                    this.newsDataLength = this.newsData.length;
                    this.newsCountDown = this.newsData.length;
                    this.xday = new Date();
                    this.today = new Date();
                    this.beforeWeek = -7;
                    this.xday.setDate(this.today.getDate() + this.beforeWeek );
                    this.startYear = this.xday.getFullYear();
                    this.startMonth = this.xday.getMonth() + 1;
                    this.startDay = this.xday.getDate();
                    this.startMonth = ("0"+this.startMonth).slice(-2);
                    this.startDay = ("0"+this.startDay).slice(-2);
                    this.startDate = new Date(this.startYear + '-' + this.startMonth + '-' + this.startDay + 'T00:00:00.000Z').getTime();
                    for (let i = 0; i < this.newsDataLength; i++) {
                        this.newsData[i].link = '/news#'+this.newsData[i].no;
                        this.resultDay = this.newsData[i].day.split('.').join('-');
                        this.noticesDate = new Date(this.resultDay + 'T00:00:00.000Z').getTime();
                        if(this.startDate <= this.noticesDate){
                            this.newsData[i].new = true;
                        }else{
                            this.newsData[i].new = false;
                        }
                        this.newsCountDown--;
                    }
                    this.display = true;
                } catch (err) {
                    this.display = true;
                }
            },
            handleOnClickOpenImg1Modal() {
                this.isOpenImg01Modal = true;
            },
            handleOnClickCloseImg1Modal() {
                this.isOpenImg01Modal = false;
            },
            handleOnClickOpenImg2Modal() {
                this.isOpenImg02Modal = true;
            },
            handleOnClickCloseImg2Modal() {
                this.isOpenImg02Modal = false;
            },
            setImages() {
                this.images.ttlPc = this.$i18n.t('images.home.ttlPc')
                this.images.ttlSp = this.$i18n.t('images.home.ttlSp')
                this.images.txtPc = this.$i18n.t('images.home.txtPc')
                this.images.txtSp = this.$i18n.t('images.home.txtSp')
                const basePath = this.contentImagePath + this.lang + '/'
                this.images.contents.length = 0
                this.contentIds.forEach(function (contentId) {
                    this.images.contents.push({
                        src: basePath + contentId + '.png',
                        itemKey: 'top.box3.item' + contentId,
                    })
                }.bind(this))
            },
            isGrantDate() {
                if(this.displayRank){
                    if (this.grantdate['year'] === undefined || this.grantdate['year'] === null) { return false; }

                    return true;
                }
            },
            isUpDate() {
                if(this.displayRank){
                    if (this.updated['year'] === undefined || this.updated['year'] === null) { return false; }

                    return true;
                }
            },
            isExRankMonth() {
                if(this.displayRank){
                    if (this.ex_bonus_title === undefined || this.ex_bonus_title === null) { return false; }
                    if (this.ex_bonus_title.ex_month_title === undefined || this.ex_bonus_title.ex_month_title === null) { return false; }
                    if (this.ex_bonus_title.ex_month_title.rank === undefined || this.ex_bonus_title.ex_month_title.rank === null) { return false; }

                    return true;
                }
            },
            isExRankMax() {
                if(this.displayRank){
                    if (this.ex_bonus_title === undefined || this.ex_bonus_title === null) { return false; }
                    if (this.ex_bonus_title.ex_max_title === undefined || this.ex_bonus_title.ex_max_title === null) { return false; }
                    if (this.ex_bonus_title.ex_max_title.rank === undefined || this.ex_bonus_title.ex_max_title.rank === null) { return false; }

                    return true;
                }
            },
            async fetchData() {
                if (this.isLogged) {
                    const data = (await userService.getUserFrontendData(true)).data;
                    const forceClubData = await userService.getForceClubInfoData(); //ForceClub退会、停止情報取

                    this.ex_bonus_title = data.title;
                    this.member_type_id = data.member_type_id
                    if(data.title !== null){
                        if(data.title.grant_date !== null){
                            this.grantdate = this.date(data.title.grant_date)
                        }
                        if(data.title.updated_at !== null){
                            this.updated = this.date(data.title.updated_at)
                        }
                    }
                    if(this.member_type_id == FORTHING_MEMBER_PARENT || this.member_type_id == FORTHING_MEMBER_SUPPORT_PARENT){
                        this.displayRank = true
                        this.isAdvanceMember = true
                        this.data = data
                    }
                    this.fetchUserFrontendData();
                    this.latestMembershipFee = data.latestMembershipFee;
                    if(this.latestMembershipFee && data.latestMembershipFee.expires_at){
                        this.expires_at = data.latestMembershipFee.expires_at.replace(/-/g, '.');
                        this.forthingRenewalDate = data.forthingRenewalDate.replace(/-/g, '.');
                        this.membertypeDetail = data.membertypeDetail; //メンバータイプ詳細（プレミアム、サポート、アップグレードメンバー）
                    }
                    this.userData = data.userData;
                    this.notForceClubMember = forceClubData.data;
                }
            },
            date(data) {
                const dt = new Date(data)
                const month_english_list = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
                var y = dt.getFullYear()
                var m = ('00' + (dt.getMonth()+1)).slice(-2)
                var d = ('00' + dt.getDate()).slice(-2)
                y = String(y).substring(2,4)
                const month_english_list_m =  month_english_list[--m]
                const arr = {"year":y, "month":month_english_list_m,  "day":d}
                return arr
            },
        },

        created() {
            this.isLogged = AuthUtil.isAuth();
            this.setImages();
            if (this.isLogged) {
                this.fetchData();
            }else{
                this.display = true;
            }
        },
        mounted() {
            this.isAuth = AuthUtil.isAuth();
        },

        watch: {
            '$i18n.locale': function(val) {
                this.setImages();
                if (this.isLogged) {
                    this.fetchData();
                }
                this.display_lang = sessionStorage.getItem('display_no')
                this.element = document.getElementById('news'+this.display_lang)
            }
        }
    }
</script>

<style scoped>
    .wrap_box{
        background-color:#FFF;
        margin-bottom: 20px;
    }
    .boxesContainer {
        text-align:left;
        background-color: #FFF;
        border-top-width: 0px;
        font-size: 10px;
        margin-bottom: 10px;
        padding:0px 20px 20px 20px;
    }
    .boxContainer{
        margin: 170px 0px 0px 0px;
        padding: 20px 20px 0px 20px;
        display: flex;
        justify-content: flex-end;
        border-bottom-width: 0px;
    }
    .news-link{
        background-color:#451493;
        color:#FFF;
        padding: 1px 5px;
        font-weight: lighter;
    }
    .news-link:hover {
        color: #bb73ee;
    }
    .news-text-link, .wrap-news {
        margin-left: auto;
        font-weight: bold;
        font-size: 15px;
    }
    .news-text-title {
        margin-right: auto;
        font-weight: bold;
        margin-left: 0px;
        font-size: 24px;  
    }
    .new{
        background-color:red;
        color:#FFF;
        margin-right: 5px;
    }
    .title{
        color:black;
        font-weight: lighter;
    }
    .title:hover {
        color: #bb73ee;
    }
    .parent {
        width: 100%;
        display: flex;
        font-size:18px;
    }
    .child{
        margin-right: 10px;
        margin-bottom: 15px;
        font-size: 18px;
    }
    .child_end{
        margin-right: 10px;
        font-size: 18px;
    }
    .exLankTextTitle {
        margin-right: auto;
        font-weight: bold;
        margin-left: 0px;
        font-size: 24px;
    }
    .exLankContainer{
        margin:0 calc(50% - 50vw);
        background-color:#FFF;
        padding-bottom: 20px;
    }
    .exLankParentTop {
        display: flex;
        font-size:18px;
        border-bottom: 1px dotted gray;
        width:700px;
        margin:auto;
        padding-top:4px;
    }
    .exLankParent {
        display: flex;
        font-size:18px;
        border-bottom: 1px dotted gray;
        width:700px;
        margin:auto;
        margin-top: 11px;
    }
    .exLankParentEnd {
        display: flex;
        font-size:18px;
        border-bottom: 1px dotted gray;
        width:700px;
        margin:auto;
        margin-top: 11px;
        justify-content: space-between;
    }

    .exLankParentEndSp {
        justify-content: flex-end; 
        display: flex;
        font-size:18px;
        width:700px;
        margin:auto;   
    }
    .floteLeft{
        float:left;
    }
    .exLankName{
        font-weight: bold;
        text-align: left;
        width: 100px;
    }
    .exChangeTwoMonths{
        margin-right: 5px;
    }
    .exChangeLank{
        margin-right: 10px;
    }
    .exRecordHigt{
        margin-right: 5px;
    }
    .exChangeHighLank{
        margin-right: 5px;
    }
    .exUpdateSp{
        margin-right: 5px;
    }
    .exChangeMonthSp{
        margin-right: 5px;
    }
    .fontSize{
        font-size: 18px;
    }
    .fontSizeName{
        font-size: 18px;
    }
    #display{
        visibility:hidden;
    }
    #displayRank{
        visibility:visible;
    }
    .forthingRenewalBox{
        text-align:left;
        font-size: 14px;
        background-color:#FFF;
        margin-bottom: 20px;
        padding:20px 20px 20px 20px;
    }
    .forthingRenewalTextLink {
        margin-left: auto;
        font-size: 14px;
        white-space:pre-wrap;
    }
    @media only screen and (max-width: 991px) {
        .boxContainer{
            margin: 50px 0px 0px 0px;
        }
        .exLankParentTop {
            width:500px;
        }
        .exLankParent {
            width:500px;
        }
        .exLankParentEnd {
            width:500px;
        }
        .exLankParentEndSp {
            width:550px;
        }
        .fontSizeName{
            font-size: 14px;
        }
        .fontSize{
            font-size:14px;
        }
        .exLankName {
            width: 80px;
        }
    }
    @media only screen and (max-width: 767px) {
        .boxContainer {
            margin: 0px 0px 0px 0px;
            border-right-width: 0px;
            border-left-width: 0px;
            border-top-width: 0px;
        }
        .boxContainer{
            margin: 20px 0px 0px 0px;
            padding: 10px 10px 0px 10px;
            display: flex;
            justify-content: flex-end;
            border-bottom-width: 0px;
            margin-right: 0px;
        }
        .boxesContainer {
            border-left-width: 0px;
            border-bottom-width: 0px;
            border-right-width: 0px;
            margin-bottom: 20px;
            padding:0px 10px 10px 10px;
        }
        .wrap_box {
            font-size: 1px;
        }
        .news-text-title{
            font-size: 20px;
        }
        .news-text-link {
            font-size: 12px;
        }
        .child{
            margin-right: 10px;
            margin-bottom: 15px;
            font-size: 14px;
        }
        .child_end{
            margin-right: 10px;
            font-size: 14px;
        }
        .exLankTextTitle {
            font-size: 20px;
        }
        .exChangeTwoMonths{
            margin-right: 2px;
        }
        .exChangeLank{
            margin-right: 3px;
        }
        .exRecordHigt{
            margin-right: 2px;
        }
        .exChangeHighLank{
            margin-right: 2px;
        }
        .exUpdateSp{
            margin-right: 2px;
        }
        .exChangeMonthSp{
            margin-right: 2px;
        }
    }
    /*スマホ用css*/
    @media screen and (max-width: 479px) { 
        .fontSizeName{
            font-size: 9px;
        }
        .fontSize{
            font-size:9px;
        }
        .exLankName {
            width: 50px;
        }

        .exLankParentTop {
            width:250px;
        }
        .exLankParent {
            width:250px;
            margin-top:3%;
        }
        .exLankParentEnd {
            width:250px;
            margin-top:3%;
        }

        .exLankParentEndSp {
            width:250px;
        }
    }
</style>
